import React from "react"

type ScrollProps = {
  children: React.ReactNode
  id: string
}

const scrollToId = ({ children, id }: ScrollProps) => {
  //
  const handleClick = () => {
    const element = document.getElementById(id)
    if (element) {
      const newPosition = element.offsetTop - 200
      window.scrollTo({
        top: newPosition,
        behavior: "smooth",
      })
    }
  }

  return (
    <div style={{ cursor: "pointer" }} onClick={handleClick}>
      {children}
    </div>
  )
}

export default scrollToId
